import { useTranslation } from "_metronic/i18n/language";
import { AsyncCreatableSelectComponent } from "app/pages/auth/Components/Select2/AsycnCreatableSelectComponent";
import { AnanseApiService } from "app/services/Ananse/AnanseApiService";
import { debounce } from "lodash";

interface Props {
  disabled?: boolean;
  className?: any;
  label?: any;
  handleChange?: any;
  value?: any;
  newOption?: any;
  required?: any;
  resetInput?: boolean;
  setNewOption?: any;
  createLabelText?: any;
  convertObject?: any;
  url: any;
}

const SelectSearch = ({
  url,
  convertObject,
  className,
  createLabelText,
  disabled,
  handleChange,
  label,
  newOption,
  required,
  resetInput,
  setNewOption,
  value
}: Props) => {
  const api = new AnanseApiService();
  const translate = useTranslation();

  const getListFromValue = async (inputValue: any) => {
    const searchedList: any[] = [];
    if (inputValue && inputValue.length >= 3) {
      try {
        let searchedData: any;
        const response = await api.makeHttpRequest({
          url: url + encodeURIComponent(inputValue)
        });
        if (response.length > 0) {
          searchedData = response;
        } else {
          searchedData = response.data;
        }
        if (searchedData && searchedData.length > 0) {
          searchedData.forEach((item: any) => {
            const converted = convertObject(item);
            if (searchedList.indexOf(converted) === -1) {
              searchedList.push(converted);
            }
          });
        }
      } catch (error) {
        // console.error(`Erro ao fazer a busca: ${error}`);
      }
    }

    return searchedList;
  };
  const promiseOptions = debounce((inputValue, callback) => {
    getListFromValue(inputValue).then(callback);
  }, 500);
  return (
    <AsyncCreatableSelectComponent
      value={resetInput ? "" : value}
      isDisabled={disabled}
      loadOptions={promiseOptions}
      placeholder={label}
      noOptionsMessage={() => translate("selectComponent.nothingFound")}
      loadingMessage={() =>
        value && value.length >= 3
          ? translate("defaultMessages.loading")
          : translate("selectComponent.minChar")
      }
      className={className}
      onChange={e => handleChange(e)}
      onInputChange={e =>
        e && setNewOption
          ? setNewOption(true)
          : setNewOption
          ? setNewOption(false)
          : null
      }
      isValidNewOption={(e: any) => e.length > 2 && newOption}
      createOptionPosition={"first"}
      formatCreateLabel={(inputValue: any) =>
        inputValue
          ? createLabelText
            ? `${createLabelText} ${inputValue}`
            : `${translate("selectComponent.create")} ${inputValue}`
          : inputValue
      }
    />
  );
};

export default SelectSearch;
